import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils/error'

export type SendAppInvitesRequest = {
  clientIds: number[]
  buildingId: number
}

const sendAppInvites = async (data: SendAppInvitesRequest) => {
  const response = await authAPI.post('/client/app-invitation', data)
  return response.data
}

export const useSendAppInvites = () => {
  return useMutation({
    mutationFn: sendAppInvites,
    onError: (error) => toastFactory.error(getApiErrorMessage(error)),
    onSuccess: () => toastFactory.success('App invites sent successfully'),
  })
}
